import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { Apollo } from 'apollo-angular'
import { catchError, debounceTime, distinctUntilChanged, filter, mergeMap, pluck } from 'rxjs/operators'
import { FormControl, FormGroup } from '@angular/forms'
import { ApolloQueryResult, gql } from '@apollo/client/core'
import { of } from 'rxjs'
import { CompanySearchResult } from './model/company-search-result'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

export const companySearchQuery = gql`
    query searchCompany($name: String!) {
        searchCompany(nameOrChamberOfCommerceNr: $name) {
            id
            name
            branchNr
            chamberOfCommerceNr
            address {
                id
                street
                houseNr
                houseNrSuffix
                zipCode
                city
                country
            }
            isMainBranch
        }
    }
`

@UntilDestroy()
@Component({
    selector: 'mg-checkout-company-picker',
    templateUrl: './checkout-company-picker.component.html',
    styleUrls: ['./checkout-company-picker.component.scss'],
})
export class CheckoutCompanyPickerComponent implements OnInit {
    displayProgressBar: boolean = false
    companySearchResult: CompanySearchResult[] = []
    displayFn: Function
    form: FormGroup

    @Output()
    companySelected: EventEmitter<any> = new EventEmitter()

    constructor(private apollo: Apollo) {}

    ngOnInit() {
        this.form = new FormGroup({ company: new FormControl('') })

        this.form.valueChanges
            .pipe(
                untilDestroyed(this),
                filter(Boolean),
                debounceTime(300),
                distinctUntilChanged(),
                mergeMap(({ company }) => {
                    this.displayProgressBar = true

                    return this.apollo
                        .query({
                            query: companySearchQuery,
                            variables: { name: company },
                        })
                        .pipe(
                            pluck<ApolloQueryResult<{ searchCompany: CompanySearchResult[] }>, CompanySearchResult[]>(
                                'data',
                                'searchCompany'
                            ),
                            catchError(() => {
                                return of([])
                            })
                        )
                })
            )
            .subscribe((result: CompanySearchResult[]) => {
                if (result[0] && !this.companySearchResult.includes(result[0])) {
                    this.displayProgressBar = false

                    this.companySearchResult = result
                }
            })
    }

    optionSelected(value) {
        this.form.setValue({ company: value.name })
        this.companySelected.emit(value)
    }
}
